interface PublishedSession {
  time: string;
  title: string;
  detail?: string;
}

interface PublishedScheduleGroup {
  id: string;
  title: string;
  ages: string;
  note?: string;
  days: { day: string; sessions: PublishedSession[] }[];
}

// Transcribed from research/schedules/schedule-1.pdf and checked against its
// rendered PNG. The source is labeled 2025; this is not a current-time promise.
// Tuesday's overlapping belt/poomsae sessions are intentional source data.
export const publishedSchedule: PublishedScheduleGroup[] = [
  {
    id: 'little-braves',
    title: 'Little Braves',
    ages: 'Ages 3–5',
    note: 'Attend only your assigned class number. Shared sparring sessions include classes 1 and 2 and require gear.',
    days: [
      { day: 'Monday', sessions: [{ time: '4:30–5:00 PM', title: 'Class 1' }] },
      { day: 'Tuesday', sessions: [{ time: '4:30–5:00 PM', title: 'Class 2' }] },
      { day: 'Wednesday', sessions: [{ time: '4:30–5:00 PM', title: 'Class 1' }] },
      { day: 'Thursday', sessions: [
        { time: '4:30–5:00 PM', title: 'Class 2' },
        { time: '5:45–6:15 PM', title: 'Sparring drills', detail: 'Classes 1 & 2 · gear required' },
      ] },
      { day: 'Friday', sessions: [{ time: '4:30–5:00 PM', title: 'Sparring', detail: 'Classes 1 & 2 · gear required' }] },
    ],
  },
  {
    id: 'kids',
    title: 'Kids Taekwondo',
    ages: 'Ages 6–11',
    days: [
      { day: 'Monday', sessions: [
        { time: '5:00–5:45 PM', title: 'Belt class', detail: 'White–orange belts' },
        { time: '5:45–6:30 PM', title: 'Belt class', detail: 'Green–black belts' },
        { time: '6:30–7:15 PM', title: 'Belt class', detail: 'White–orange belts' },
        { time: '7:15–8:00 PM', title: 'Fitness / self-defense', detail: 'Ages 10+ · all belts' },
      ] },
      { day: 'Tuesday', sessions: [
        { time: '5:00–5:45 PM', title: 'Belt class', detail: 'White–orange belts' },
        { time: '5:15–5:45 PM', title: 'Poomsae practice', detail: 'For competition' },
        { time: '5:45–6:30 PM', title: 'Sparring drills', detail: 'All belts · gear required' },
      ] },
      { day: 'Wednesday', sessions: [
        { time: '5:00–5:45 PM', title: 'Belt class', detail: 'Green–black belts' },
        { time: '5:45–6:30 PM', title: 'Belt class', detail: 'White–orange belts' },
        { time: '6:30–7:15 PM', title: 'Belt class', detail: 'Green–black belts' },
        { time: '7:15–8:00 PM', title: 'Belt class', detail: 'White–orange belts' },
      ] },
      { day: 'Thursday', sessions: [
        { time: '5:00–5:45 PM', title: 'Belt class: poomsae', detail: 'Green–black belts' },
        { time: '5:45–6:30 PM', title: 'Sparring drills', detail: 'All belts · gear required' },
      ] },
      { day: 'Friday', sessions: [{ time: '5:00–5:45 PM', title: 'Sparring', detail: 'All belts · gear required' }] },
    ],
  },
  {
    id: 'teens-adults',
    title: 'Teens & adults',
    ages: 'Ages 12–adult',
    days: [
      { day: 'Monday', sessions: [
        { time: '5:45–6:30 PM', title: 'Belt class', detail: 'All belts' },
        { time: '7:15–8:00 PM', title: 'Fitness / self-defense', detail: 'All belts' },
      ] },
      { day: 'Tuesday', sessions: [
        { time: '5:15–5:45 PM', title: 'Poomsae practice', detail: 'For competition' },
        { time: '5:45–6:30 PM', title: 'Sparring drills', detail: 'All belts · gear required' },
      ] },
      { day: 'Wednesday', sessions: [
        { time: '5:00–5:45 PM', title: 'Belt class', detail: 'All belts' },
        { time: '6:30–7:15 PM', title: 'Belt class', detail: 'All belts' },
      ] },
      { day: 'Thursday', sessions: [
        { time: '5:00–5:45 PM', title: 'Belt class', detail: 'All belts' },
        { time: '5:45–6:30 PM', title: 'Sparring drills', detail: 'All belts · gear required' },
      ] },
      { day: 'Friday', sessions: [{ time: '5:00–5:45 PM', title: 'Sparring', detail: 'All belts · gear required' }] },
    ],
  },
  {
    id: 'competition-team',
    title: 'Competition Team',
    ages: 'All ages & belts',
    note: 'An extra fee applies.',
    days: [
      { day: 'Tuesday', sessions: [{ time: '6:30–8:00 PM', title: 'Competition Team training' }] },
      { day: 'Thursday', sessions: [{ time: '6:30–8:00 PM', title: 'Competition Team training' }] },
    ],
  },
];
